import supabaseClient from '@/api/supabaseClient.ts';
import { SupabaseClient } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';
import { StoreFileRequest } from '@/types/request/StoreFileRequest';

const useStorage = (storage: string) => {
  const client = supabaseClient;

  const mutationFn = async (request: StoreFileRequest) => {
    return storeFile(client, request, storage);
  };

  return {
    store: {
      ...useMutation({
        mutationFn,
      }),
    },
    getPublicUrl: (path: string) => getPublicUrl(client, storage, path).data.publicUrl,
  };
};

export default useStorage;

async function storeFile(client: SupabaseClient, request: StoreFileRequest, storage: string) {
  if (!request.file) throw new Error('file is required');
  if (!request.path) throw new Error('path is required');

  const { error, data } = await client.storage.from(storage).upload(request.path, request.file, { upsert: true });

  if (error) throw new Error(error.message);

  return data;
}

function getPublicUrl(client: SupabaseClient, storage: string, path: string) {
  return client.storage.from(storage).getPublicUrl(path);
}
